<template>
  <div class="nav-menu">
    <div class="logo">
      <img class="img" src="../../assets/img/logo.svg" alt="logo" />
      <span v-if="!collapse" class="title">Vue3+TS</span>
    </div>
    <el-menu
      :key="menuKey"
      :default-active="defaultValue"
      :default-openeds="defaultOpeneds"
      unique-opened
      class="el-menu-vertical"
      :collapse="collapse"
      background-color="#0c2135"
      text-color="#b7bdc3"
      active-text-color="#0a60bd"
    >
      <template v-for="item in userMenus" :key="item.id">
        <!-- 二级菜单 -->
        <template v-if="item.menuType === 'M'">
          <!-- 二级菜单的可以展开的标题 -->
          <el-sub-menu :index="item.id + ''">
            <template #title>
              <el-icon v-if="item.meta?.icon">
                <!-- 动态图标 -->
                <component :is="item.meta.icon"></component>
              </el-icon>
              <span>{{ item.menuName }}</span>
            </template>
            <!-- 遍历里面的item -->
            <template v-for="subitem in item.children" :key="subitem.id">
              <template v-if="subitem.menuType === 'M'">
                <!--     存在二级子目录           -->
                <el-sub-menu :index="subitem.id + ''">
                  <template #title>
                    <!--                    <el-icon v-if="subitem.meta?.icon">
                      <component :is="subitem.meta.icon"></component>
                    </el-icon>-->
                    <span>{{ subitem.menuName }}</span>
                  </template>
                  <template v-for="subsubitem in subitem.children" :key="subsubitem.id">
                    <el-menu-item :index="subsubitem.id + ''" @click="handleMenuItemClick(subsubitem)">
                      <i v-if="subsubitem.meta?.icon" :class="subsubitem.meta?.icon"></i>
                      <span>{{ subsubitem.menuName }}</span>
                    </el-menu-item>
                  </template>
                </el-sub-menu>
              </template>
              <template v-else-if="subitem.menuType === 'C'">
                <el-menu-item :index="subitem.id + ''" @click="handleMenuItemClick(subitem)">
                  <i v-if="subitem.meta?.icon" :class="subitem.meta?.icon"></i>
                  <span>{{ subitem.menuName }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-sub-menu>
        </template>
        <!-- 一级菜单 -->
        <template v-else-if="item.menuType === 'C'">
          <el-menu-item :index="item.id + ''">
            <i v-if="item.meta?.icon" :class="item.meta?.icon"></i>
            <span>{{ item.menuName }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue'
import { useStore } from '@/store'
import { useRouter, useRoute } from 'vue-router'
import { pathMapToMenuWithParent } from '@/utils/map-menus'
import { RouterVo } from '@/api/vo/user-vo'

const props = defineProps({
  collapse: Boolean
})

// store
const store = useStore()
const userMenus: ComputedRef<RouterVo[]> = computed(() => store.state.login.userMenus)

// router
const router = useRouter()
const route = useRoute()

// 根据当前路由（含标签切换）动态计算选中的菜单项和展开的父级目录
const activeMenuResult = computed(() => {
  const path = route.path
  return pathMapToMenuWithParent(userMenus.value, path)
})

const defaultValue = computed(() => {
  const { menu } = activeMenuResult.value
  return menu?.id ? String(menu.id) : ''
})

// 仅展开当前选中菜单所在的父级目录，配合 unique-opened 实现手风琴效果
const defaultOpeneds = computed(() => {
  const { parent } = activeMenuResult.value
  return parent?.id ? [String(parent.id)] : []
})

// 路由变化时更新 key，强制菜单重新挂载以正确应用 default-openeds（解决 Element Plus 动态更新失效）
const menuKey = computed(() => route.path)

// event handle
const handleMenuItemClick = (item: RouterVo) => {
  router.push({
    path: item.path ?? '/not-found'
  })
}
</script>

<style scoped lang="less">
.nav-menu {
  height: 100%;
  background-color: #001529;

  .logo {
    display: flex;
    height: 28px;
    padding: 12px 10px 8px 10px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .img {
      height: 100%;
      margin: 0 10px;
    }

    .title {
      font-size: 16px;
      font-weight: 700;
      color: white;
    }
  }

  .el-menu {
    border-right: none;
  }

  // 目录
  .el-submenu {
    background-color: #001529 !important;
    // 二级菜单 ( 默认背景 )
    .el-menu-item {
      padding-left: 50px !important;
      background-color: #0c2135 !important;
    }
  }

  ::v-deep .el-submenu__title {
    background-color: #001529 !important;
  }

  // hover 高亮
  .el-menu-item:hover {
    color: #fff !important; // 菜单
  }

  .el-menu-item.is-active {
    color: #fff !important;
    background-color: #0a60bd !important;
  }
}
</style>
